import styled from 'styled-components';
import { Icon, Form, Label, ErrorMsg } from '@studio/legacy-components';

export const InformativeLabelText = styled.span`
  ${Icon} {
    color: var(--dark-resting);
  }
`;

export const DetailsForm = styled(Form)`
  // @todo this doesn't seem to match the global placement for form errors
  ${Label} {
    padding-bottom: 24px;

    ${ErrorMsg} {
      position: absolute;
      bottom: 0px;
    }
  }
`;
